var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgToastSuccessIcon = function SvgToastSuccessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00B74A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.8846 11-1.0578 1.0894c-2.901 2.9681-5.547 5.8877-8.3494 8.8014l-3.4353-2.8-1.17-.9556L11 19.5242l1.17.9556 4.493 3.6697L17.7114 25l.9454-.9652c3.2258-3.3004 6.1213-6.5482 9.2855-9.7857L29 13.1597 26.8846 11Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.7638 4.609 1.0761-.6522L12.013 0l-.9256.5582C6.0297 3.6153 0 9.2097 0 18.4962c0 9.2866 6.0304 14.8803 11.0885 17.9374l.937.5658 2.7571-3.9739-1.0604-.6426c-5.5326-3.3551-8.705-8.4164-8.705-13.8867 0-5.4557 3.1882-10.517 8.7466-13.8873M28.9868.5582 28.0613 0l-2.8265 3.9568 1.0755.6521c5.5584 3.3696 8.746 8.431 8.746 13.8873 0 5.4703-3.1718 10.5316-8.7032 13.8873l-1.0604.642L28.0493 37l.9375-.567c5.0588-3.0571 11.088-8.6509 11.088-17.9368 0-9.2865-6.0292-14.8809-11.088-17.938"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToastSuccessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/toast-success-icon.face8888.svg";
export { ForwardRef as ReactComponent };